import { render, staticRenderFns } from "./ProductionCalendar.vue?vue&type=template&id=2868a8ea&"
import script from "./ProductionCalendar.vue?vue&type=script&lang=js&"
export * from "./ProductionCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ProductionCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports